import { Component, useState } from "react";
import { AnimatePresence } from "framer-motion";
import "@/App.css";
import VisitorProvider from "@/context/VisitorContext";
import { WindowProvider } from "@/context/WindowContext";
import BootScreen from "@/components/desktop/BootScreen";
import Desktop from "@/components/desktop/Desktop";
import { APPS } from "@/data/windowRegistry";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { err: null };
  }

  static getDerivedStateFromError(err) {
    return { err };
  }

  render() {
    if (this.state.err) {
      return (
        <div className="flex h-full w-full items-center justify-center bg-[#0B0F17] p-6">
          <div className="glass max-w-md rounded-2xl p-8 text-center" data-testid="error-boundary">
            <p className="font-mono text-sm text-red-400">segmentation fault (core dumped)</p>
            <p className="mt-2 text-sm text-slate-300">Something crashed unexpectedly. Reload the workspace to try again.</p>
            <button
              onClick={() => window.location.reload()}
              data-testid="error-reload"
              className="mt-5 rounded-lg bg-sonoma px-4 py-2 font-mono text-xs text-white transition-colors duration-150 hover:bg-[#0062CC]"
            >
              reload workspace
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function Shell() {
  const [booted, setBooted] = useState(false);

  return (
    <div className="grain relative h-full w-full select-none overflow-hidden bg-[#0B0F17] text-slate-100" data-testid="app-root">
      <AnimatePresence>{!booted && <BootScreen key="boot" onDone={() => setBooted(true)} />}</AnimatePresence>
      {booted && (
        <WindowProvider apps={APPS}>
          <VisitorProvider>
            <Desktop />
          </VisitorProvider>
        </WindowProvider>
      )}
    </div>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <Shell />
    </ErrorBoundary>
  );
}
